'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/postcss-px2rem/node_modules/supports-color/browser.js
// module id = KssI
// module chunks = 1